skrilla.controller('promotionDetailsCtrl', function ($scope, $stateParams, searchService) {

    const milestonePurposes = ['PROMOTION', 'REFERRAL', 'DEFAULT_REFERRAL'];
    searchService.get("promotions/definitions/" + $stateParams.id).then(function(response){
        $scope.promotion = response.data;
        $scope.showMilestones = $scope.promotion &&
            $scope.promotion.purpose !== 'BTAG_REFERRAL' &&
            milestonePurposes.includes($scope.promotion.purpose)
    })

});
